import { Base } from "../../framework/base";
import { EnumHelper, RecordEducationScopeUnit, UserFurtherEducationState } from "../enums";
var RecordListItemUserFurtherEducation = /** @class */ (function () {
    function RecordListItemUserFurtherEducation(obj) {
        this.id = obj && obj.id || "";
        this.furtherEducationId = obj && obj.furtherEducationId || "";
        this.furtherEducationCode = obj && obj.furtherEducationCode || "";
        this.startDate = obj && obj.startDate || 0;
        this.endDate = obj && obj.endDate || null;
        this.validityEndDate = obj && obj.validityEndDate || null;
        this.archived = obj && obj.archived || false;
        this.scope = obj && obj.scope || 0;
        this.scopeUnit = obj && obj.scopeUnit || RecordEducationScopeUnit.Hour;
        this.scopeUnitStr = EnumHelper.RecordEducationScopeUnitToStr(this.scopeUnit);
        this.state = obj && obj.state || UserFurtherEducationState.Valid;
        this.hasAttachments = obj && obj.hasAttachments || false;
        this.modifyDate = obj && obj.modifyDate || 0;
    }
    RecordListItemUserFurtherEducation.prototype.getIsArchived = function () {
        return this.archived;
    };
    RecordListItemUserFurtherEducation.sortRecordListItemUserFurtherEducations = function (items, column, asc) {
        if (!items && items.length < 2)
            return items;
        if (column === "validityDuration") {
            return items.sort(function (a, b) {
                if (!a || !b)
                    return 0;
                if (!a.validityEndDate && !b.validityEndDate) {
                    return ((asc ? 1 : -1) * -1 * Base.numCompare(a.startDate, b.startDate));
                }
                if (!a.validityEndDate) {
                    return asc ? 1 : -1;
                }
                if (!b.validityEndDate) {
                    return asc ? -1 : 1;
                }
                return (asc ? 1 : -1) * Base.numCompare(a.validityEndDate, b.validityEndDate);
            });
        }
        else if (column === "validityEndDate") {
            return items.sort(function (a, b) { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.numCompare(a.validityEndDate, b.validityEndDate)); });
        }
        else {
            return items.sort(function (a, b) { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.strCompare(a.furtherEducationCode, b.furtherEducationCode)); });
        }
    };
    return RecordListItemUserFurtherEducation;
}());
export { RecordListItemUserFurtherEducation };
